import { FormattedMessage } from 'react-intl';
import { noop } from 'lodash';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { MoreToolsDropdown } from '@app/components';

import './ProjectDetailsHeroSection.scss';

const cnBem = createBemBlockBuilder(['projectDetailsHeroSection']);

interface ProjectDetailsHeroSectionProps {
  title: string;
  description: string;
  openEditProjectModal: () => void;
}

const RECORD_TOOLS = {
  editProject: {
    label: (
      <FormattedMessage id="shared.editProject" defaultMessage="Edit project" />
    ) as unknown as string,
    icon: faPenToSquare,
  },
  delete: {
    label: (
      <FormattedMessage id="recordTools.delete" defaultMessage="Delete" />
    ) as unknown as string,
    icon: faTrash,
    onClick: noop,
  },
};

export const ProjectDetailsHeroSection = ({
  title,
  description,
  openEditProjectModal,
}: ProjectDetailsHeroSectionProps) => (
  <div className={cnBem('__titleContainer')}>
    <h1 className={cnBem('__title')}>{title}</h1>
    <p className={cnBem('__description')}>{description}</p>
    <div className={cnBem('__moreTools')}>
      <MoreToolsDropdown
        tools={[
          {
            ...RECORD_TOOLS.editProject,
            onClick: openEditProjectModal,
          },
          RECORD_TOOLS.delete,
        ]}
      />
    </div>
  </div>
);
